import React from 'react'
import "./TestMatch.css";
import MatchOdds from './MatchOdds'
export const TestMatch = () => {
  return (
    <div className="wbb-container">
        <div
          className="wbb-title"
          style={{ backgroundColor: "#441010ff", height: "150px" }}
        ></div>
        <MatchOdds />
      </div>
  )
}
